import { removeTaskError } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getRemoveTaskError(task) {
      const req = getState().find(({ task: { uuid } }) => uuid === task.uuid);

      return req ? req.error : removeTaskError;
    },
    isRemoveTaskRequestFailure(task) {
      const state = getState().find(({ task: { uuid } }) => uuid === task.uuid);

      return state ? state.request.isFailure : false;
    },
    isRemoveTaskRequestPending(task) {
      const state = getState().find(({ task: { uuid } }) => uuid === task.uuid);

      return state ? state.request.isPending : false;
    },
    isRemoveTaskRequestSuccess(task) {
      const state = getState().find(({ task: { uuid } }) => uuid === task.uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
